module.exports = __webpack_public_path__ + "img/signup.9bb6f61a.png";